import CurrentRouteContext from "src/context/CurrentRouteContext";
import { useContext } from "react";

const useRouter = () => useContext(CurrentRouteContext);

export default useRouter;
